import React, { Component } from "react";
import { Link } from "react-router-dom";
import '../Styles/Header.css'

export default class Header extends Component {
  render() {

    window.onscroll = function() {
      var scroll = window.pageYOffset;
      var header = document.querySelector("header");
    
      if (scroll >= 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    };
  
    return (
      <header 
        className="header"
        data-aos="fade-down" 
        data-aos-duration="800"
      >
        <nav>
          <ul className="links-list">
            <li><a className="link" href="#home">Home</a></li>
            <li><a className="link" href="#about">Sobre</a></li>
            <li><a className="link" href="#skills">Habilidades</a></li>
            <li><a className="link" href="#projects">Projetos</a></li>
            <li><Link className="link" to="/professional">Profissional</Link></li>
            <li><a className="link" href="#contact">Contato</a></li>
          </ul>
        </nav>
      </header>
    )
  }
}